import chatApi from 'lib/api/chat';
import create from 'zustand';
import { MAX_GROUP_MEMBER_DEFAULT } from '../constant';
import { IChatGroupPolicyStore } from './types';

const chatGroupPolicyStore = create<IChatGroupPolicyStore>((set) => ({
  maxMembers: MAX_GROUP_MEMBER_DEFAULT,
  fetchMaxMembers: async () => {
    await chatApi.getMaxMemberInGroup()
      .then((res) => {
        const { max_member: maxMembers } = res.data.data;

        // -1 for admin
        set({ maxMembers: maxMembers - 1 });
      })
      .catch(() => {});
  },
}));

export default chatGroupPolicyStore;
